const state = {
  routePermissions: [],
};

const getters = {};
const mutations = {
  setRoutePermissions(state, routePermissions) {
    state.routePermissions = routePermissions;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
